module.exports = __webpack_public_path__ + "img/dumpster-fire.addc0916.svg";